import { Button } from '@la/ds-ui-components';
import * as S from './DivisionCardFooter.styles';

type DivisionCardFooterProps = {
  onCancel: () => void;
  onSave: () => void;
  shouldUpdateFields?: boolean;
  subProgramLabel: string;
};

export function DivisionCardFooter({
  onCancel,
  onSave,
  shouldUpdateFields,
  subProgramLabel,
}: DivisionCardFooterProps) {
  return (
    <S.DivisionCardFooter>
      <S.DivisionCardCancelButton
        variant="text"
        size="medium"
        onClick={onCancel}
      >
        Cancel
      </S.DivisionCardCancelButton>
      <Button variant="primary" size="medium" onClick={onSave}>
        {shouldUpdateFields ? 'Update and save' : `Save ${subProgramLabel}`}
      </Button>
    </S.DivisionCardFooter>
  );
}
